// Put your application javascript here
window.addEventListener("load", application, false);
function application() {

  let scrollDelta = 0;
  const threshold = 50;
  let lastScrollY = window.scrollY;
  
  const headerSticky = document.querySelector('.header-c');

  // document.querySelector('.toggler').onclick = function (){ 
  //   toggleHeaderMenu();
  //   popupBodyOn();
  // };
  // document.querySelector('.wedding-toggler').onclick = function (){ 
  //   this.classList.remove('active');
  //   document.querySelector('.wedding-m-menu').classList.add('active');
  // };
  // document.querySelector('.nav-m-close').onclick = function (){ 
  //   toggleHeaderMenu();
  //   popupBodyOff(); 
  //   document.querySelector('.wedding-toggler').classList.add('active');
  //   document.querySelector('.wedding-m-menu').classList.remove('active');
  // };
  // function toggleHeaderMenu() {
  //   document.querySelector('.nav-m').classList.toggle("active");
  // }
  

  const dropdownItems = document.querySelectorAll('.dropdown-item');

  dropdownItems.forEach(function(item) {
    item.onmouseover = function() {
      // Remove 'active' class from all items and 'is-dropdown' class from body
      document.querySelectorAll('.dropdown-item').forEach(function(item) {
        item.classList.remove("active");
      });
      document.querySelector('body').classList.add("is-dropdown");

      // Add 'active' class to the current item
      this.closest('.dropdown-item').classList.add("active");
    };

    item.onmouseout = function() {
      // Remove 'active' class from the current item
      this.closest('.dropdown-item').classList.remove("active");

      // Check if any dropdown item is still active
      let anyActive = Array.from(document.querySelectorAll('.dropdown-item')).some(item => item.classList.contains("active"));

      // Remove 'is-dropdown' class from body if no item is active
      if (!anyActive) {
        document.querySelector('body').classList.remove("is-dropdown");
      }
    };
  });
  // document.querySelector('.dropdown-item > span').onclick = function (){ 
  //   console.log('click');
  //   this.closest('.dropdown-item').classList.toggle("active");
  //   document.querySelector('body').classList.toggle("is-dropdown");
  // };
  document.querySelector('.dropdown-overlay').onclick = function (){
    document.querySelectorAll('.dropdown-item').forEach(function(item) {
      item.classList.remove("active");
    });
    document.querySelector('body').classList.remove("is-dropdown");
  };
  
  // document.querySelector('.nav-m-search .search-toggler').onclick = function (){ 
  //   toggleSearch();
  //   document.querySelector('.nav-m').classList.remove("active");
  // };
  // document.querySelector('.desctop .search-toggler').onclick = function (){ 
  //   toggleSearch();
  // };
  // document.querySelector('.nav-search-close').onclick = function (){ 
  //   toggleSearch();
  //   if (!document.querySelector('.nav-m').classList.contains('active')) {
  //     popupBodyOff();
  //   }
  // };
  
  // function toggleSearch() {
  //   document.querySelector('.nav-search-block').classList.toggle("active");
  // }

  document.querySelectorAll('.nav-footer-h').forEach(item => {
    item.addEventListener('click', event => {
      const itemStatus = item.parentNode.classList.contains("active");
      [...item.parentElement.parentElement.children].forEach(sib => sib.classList.remove('active'));
      if(!itemStatus) {
        item.parentNode.classList.add("active");
      }
    });
  });


  document.querySelectorAll('.faq-item .faq-q').forEach(item => {
    item.addEventListener('click', event => {
      item.parentNode.classList.toggle("active"); 
    });
  });


  // function toggleCart() {
  //   document.querySelector('.popup-cart').classList.toggle("active");
  // }

  // SlideIn About text
  const slideObjects = document.querySelectorAll('.js-slidein');
  slideObjects.forEach((el, i) => {
    console.log('el: ' + el);
    const bottomObject = el.getBoundingClientRect().top;
    const bottomWindow = window.scrollY + window.innerHeight;

    if (bottomWindow > bottomObject) {
      el.classList.remove('js-slidein');
    }

    console.log('Obj: ' + bottomObject + ', Win: ' + bottomWindow);
  });
  
  window.addEventListener('scroll', function() {
    const slideObjects = document.querySelectorAll('.js-slidein');
    slideObjects.forEach((el, i) => {    
      const bottomObject = el.getBoundingClientRect().top + el.clientHeight / 2;
      const bottomWindow = window.scrollY + window.innerHeight;

      if (bottomWindow > bottomObject) {
        el.classList.add('js-slidein-visible');
      }

      // console.log('ObjScroll: ' + bottomObject + ', WinScroll: ' + bottomWindow);
    });
  });

  if (document.querySelector('.product-shipping-line .tip') !== null) {

    document.querySelectorAll('.product-shipping-line .tip').forEach(infotip => {
      tippy(infotip, {
        content(reference) {
          const template = reference.nextElementSibling;
          return template.innerHTML;
        },
        allowHTML: true,
        trigger: 'click',
        interactive: true,
      });
    });

  }

  // Info tips
  if (document.querySelector('.product-details-list-item .tip') !== null) {

    document.querySelectorAll('.product-details-list-item .tip').forEach(infotip => {
      // console.log('infotip:');
      tippy(infotip, {
        content(reference) {
          const template = reference.nextElementSibling;
          return template.innerHTML;
        },
        allowHTML: true,
        trigger: 'click',
        interactive: true,
      });
    });

  }

  window.addEventListener("scroll", function(event) {
    // sticky header 
    const top = this.scrollY;
    if (document.querySelector('body').classList.contains('product-page') || document.querySelector('body').classList.contains('tablet-page')) {
      if(top > 0) {
        document.querySelector('body').classList.add('scrolled');
      } else {
        document.querySelector('body').classList.remove('scrolled');
      }
    } else {
      if(top > 42) {
        document.querySelector('body').classList.add('scrolled');
      } else {
        document.querySelector('body').classList.remove('scrolled');
      }
    }

    const diff = top - lastScrollY;

    if (Math.abs(diff) > 5) {
      scrollDelta += diff;
  
      if (scrollDelta > threshold && top > 42) {
        headerSticky.classList.remove('show');
        scrollDelta = 0;
      }
  
      if (scrollDelta < -threshold) {
        headerSticky.classList.add('show');
        scrollDelta = 0;
      }
    }

    lastScrollY = top;
    
    // sticky addtocart 
    if (document.querySelector('.section-product') !== null) {
      let btnTop = 0;
      if (document.getElementById('chooseSettingBtn') !== null) {
        btnTop = document.getElementById('chooseSettingBtn').getBoundingClientRect().top;
      } else if (document.getElementById('addtocartbtn') !== null) {
        btnTop = document.getElementById('addtocartbtn').getBoundingClientRect().top;
      }
      if(btnTop < 0) {
        document.querySelector('.btns-m-sticky').classList.add('visible');
      } else {
        document.querySelector('.btns-m-sticky').classList.remove('visible');
      }
    }
  }, false);

  // Shopify Inbox Chat
  function initChatToggler() {
    const chatTogglers = document.querySelectorAll(".chat-toggler");
    // chatTogglers.forEach(toggler => toggler.addEventListener("click", () => {
    //   console.log('listenChatToggler');
    //     toggleChat();
    // }));    
    chatTogglers.forEach((toggler) => {
      toggler.classList.add("visible");
      toggler.addEventListener("click", () => {
        toggleChat();
      });    
    });
  };
  function getChatIFrame() {
    return document.getElementById('ShopifyChat') || document.getElementById('dummy-chat-button-iframe') || null;
  }
  function toggleChat() {
    let firstTimeChat = true;
    const chatIFrame = getChatIFrame();
    if (document.getElementById('ShopifyChat')) {
      firstTimeChat = false;
    }
    // document.getElementById('dummy-chat-button-iframe').contentDocument.querySelector('.chat-toggle').click();
      setTimeout(function () {
          chatIFrame.classList.add('active');
          if (chatIFrame.shadowRoot.querySelector('.chat-toggle')) {
            chatIFrame.shadowRoot.querySelector('.chat-toggle').click();
          }
          if (firstTimeChat) {
            setTimeout(function () {
              if (document.getElementById('ShopifyChat')) {
                document.getElementById('ShopifyChat').classList.add('active');
                if (document.getElementById('ShopifyChat').shadowRoot.querySelector('.chat-toggle')) {
                  document.getElementById('ShopifyChat').shadowRoot.querySelector('.chat-toggle').click();
                  // setTimeout(function () {
                  //   chatIFrame.addEventListener('load', chatFrameListener(chatIFrame));
                  // }, 500);
                }
              }
            }, 500);
          }
        
          // if (typeof Shopify.Chat !== 'undefined') {
          //   // }
          // }
          // else if (document.getElementById('dummy-chat-button-iframe')) {
          //   document.getElementById('dummy-chat-button-iframe').classList.add('active');
          //   if (document.getElementById('dummy-chat-button-iframe').contentDocument.querySelector('.chat-toggle')) {
          //     document.getElementById('dummy-chat-button-iframe').contentDocument.querySelector('.chat-toggle').click();
          //   }
          //   setTimeout(function () {
          //     if (document.getElementById('ShopifyChat')) {
          //       document.getElementById('ShopifyChat').classList.add('active');
          //       if (document.getElementById('ShopifyChat').contentDocument.querySelector('.chat-toggle')) {
          //         document.getElementById('ShopifyChat').contentDocument.querySelector('.chat-toggle').click();
          //       }
          //     }
          //     if (typeof Shopify.Chat !== 'undefined') {
          //     }
      }, 200);
    
      setTimeout(function () {
        // Chat close 

        const chatIFrameUpdated = document.getElementById('ShopifyChat') || document.getElementById('dummy-chat-button-iframe') || null;
        chatIFrameUpdated.addEventListener('load', chatFrameListener(chatIFrameUpdated));
        // if (firstTimeChat) {
        //   setTimeout(function () {
        //     chatIFrame.addEventListener('load', chatFrameListener(chatIFrame));
        //   }, 500);
        // }
        // const chatFrame1 = document.getElementById('dummy-chat-button-iframe');
        // if (chatFrame1) {
        //   chatFrame1.addEventListener('load', chatFrameListener(chatFrame1));
        // } else {
        //   const chatFrame2 = document.getElementById('ShopifyChat');
        //   if (chatFrame2) {
        //     chatFrame2.addEventListener('load', chatFrameListener(chatFrame2));
        //   }
        // }
      }, 1000);
        
  
        // if (typeof Shopify.Chat !== 'undefined') {
        //   console.log('CHAT!');
        // }
        
        
      return false;
  };

  function chatFrameListener(frame) {
    const chatWindow = frame.contentWindow;
    if (chatWindow) {
      const closeButton = chatWindow.document.querySelector('.chat-app--close-button');
      if (closeButton) {
        closeButton.addEventListener('click', function() {
          frame.classList.remove('active');
        });
      } else {
        setTimeout(function () {
          const closeButton2 = chatWindow.document.querySelector('.chat-app--close-button');
          if (closeButton2) {
            closeButton2.addEventListener('click', function() {
              frame.classList.remove('active');
            });
          }
        }, 3000);
      }
    }
  }
  
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === "childList") {
        const shopifyChatDiv1 = document.getElementById("shopify-chat");
        const shopifyChatDiv2 = document.getElementById("dummy-chat-button-iframe");
        if (shopifyChatDiv1 || shopifyChatDiv2) {
          initChatToggler();
          observer.disconnect();
          break;
        }
      }
    }
  });

  // Start observing changes in the DOM
  observer.observe(document.documentElement, { childList: true, subtree: true });
  
  
  

  // description More link
  const descs = document.querySelectorAll('.product-description');
  [...descs].forEach(desc => {
    let descH = desc.offsetHeight;
    let descLineH;
    if (desc.closest('.product-desc') !== null) {
      descLineH = 35; // desktop
    } else {
      descLineH = 21; // mobile
    }

    if (descH > descLineH * 2) {
      desc.classList.add('collapsed');
      desc.insertAdjacentHTML("beforeend", '<span class="more"><span class="ellipsis">...</span> <span class="txt">Read More</span></span>');
      setTimeout(function () {
        desc.querySelector('.more').onclick = function (){ 
          this.parentNode.classList.add("expanded");
          this.parentNode.classList.remove('collapsed');
        };
      }, 100);
    } else {
      desc.classList.add('expanded');
    }
  
  });



  
  // appointment - virtual
  // const virtualVideo = document.getElementById('virtualVideo');
  // console.log('VIRTUAL', virtualVideo);
  // if (virtualVideo.length !== null) {
  //   console.log('VIRTUAL2', virtualVideo.src);
  //   let mobileSrc = "https://cdn.shopify.com/videos/c/o/v/adc6195bbff8425fbdf335230b227a23.mov";
  //   let desktopSrc = "https://cdn.shopify.com/videos/c/o/v/0b05de9374df4b3ca4f2c53a7d90a828.mp4";
     
  //   if ($(window).width() < 992) {
  //        virtualVideo.src = mobileSrc;
  //   } else {
  //        virtualVideo.src = desktopSrc;
  //   }
  //   virtualVideo.className.add('active');
  // }

  // free filter
  if (document.querySelector('.free-filter') !== null) {
    // const activeFreeEl = document.querySelector('.free-filter .active');
    // if (activeFreeEl) {
      // activeFreeEl.scrollIntoView();
    // }
    var activeElement = document.querySelector('.free-filter .active');
    if (activeElement) {
      var parentElement = activeElement.parentElement;
      while (parentElement && parentElement !== document && parentElement.className !== 'free-filter') {
        parentElement = parentElement.parentElement;
      }
      if (parentElement) {
        var scrollLeft = activeElement.offsetLeft - parentElement.offsetLeft;
        var firstElement = document.querySelector('.free-filter li:first-child a');
        var lastElement = document.querySelector('.free-filter li:last-child a');
        if (activeElement === firstElement) {
          scrollLeft -= 16;
        } else if (activeElement === lastElement) {
          scrollLeft -= 16;
        } else {
          scrollLeft -= 8;
        }
        parentElement.scrollLeft = scrollLeft;
      }
    }
    // setTimeout(function () {
    //   document.querySelector('.free-filter').classList.add('visible');
    // }, 200);
  }
}

function onSubscribeFormSubmit(token=null) {

  // Get the form data
  const formData = new FormData(subscribeForm);
  // formData.append('h-captcha-response', token)
  // Submit the form data using fetch
  fetch('/contact#contact_form', {
    method: 'POST',
    body: formData
  })
    .then(function(response) {
      // console.log('response: ', response);
      document.querySelector('.footer-signup').classList.add('success');

      if (response.ok) {
        // console.log('Form submitted successfully!');
        // Show success message
        
        document.querySelector('.footer-signup .form-message--success').classList.remove('hidden');
        document.querySelector('.footer-signup .form-message--error').classList.add('hidden');
        // document.querySelector('.footer-signup form').classList.add('hidden');
        
      } else {
        // console.log('Form submission failed.');
        // Show error message
        document.querySelector('.footer-signup .form-message--error').classList.remove('hidden');
      }
    })
    .catch(function(error) {
      // Show error message
      // console.log('Error submitting form:', error);
      // console.log('error: ', error);
      document.querySelector('.footer-signup .form-message--error').classList.add('hidden');
    });
}

document.addEventListener('DOMContentLoaded', () => {
  const urlParams = new URLSearchParams(window.location.search);
  const contactPosted = urlParams.get('customer_posted');

  if (contactPosted) {
    const successTag = document.querySelector('.footer-signup .form-message--success');
    const errorTag = document.querySelector('.footer-signup .form-message--error');
    if (contactPosted === 'true') {
      document.querySelector('.footer-signup')?.classList.add('success');
      if (successTag) {
        successTag.classList.remove('hidden');
      }
      if (errorTag) {
        errorTag.classList.add('hidden');
      }
    } else {
      if (successTag) {
        successTag.classList.add('hidden');
      }
      if (errorTag) {
        document.querySelector('.footer-signup')?.classList.add('success');
        errorTag.classList.remove('hidden');
      }
    }

    setTimeout(() => {
      if (errorTag) {
        document.querySelector('.footer-signup')?.classList.remove('success');
        errorTag.classList.add('hidden');
      }
      if (successTag) {
        document.querySelector('.footer-signup')?.classList.remove('success');
        successTag.classList.add('hidden');
      }
    }, 3000);
  } else {
    
  }
});

// footer subscribe form
const subscribeForm = document.getElementById('ContactFooter2');
const emailInput = document.getElementById('contact-footer-form-input');

emailInput?.addEventListener('focus', () => {
  document.querySelector('.footer-signup').classList.remove('success');
  document.querySelector('.footer-signup .form-message--success').classList.add('hidden');
  document.querySelector('.footer-signup .form-message--error').classList.add('hidden');
});

emailInput?.addEventListener('change', () => {
  document.querySelector('.footer-signup').classList.remove('success');
  document.querySelector('.footer-signup .form-message--success').classList.add('hidden');
  document.querySelector('.footer-signup .form-message--error').classList.add('hidden');
});

// const recaptchaSiteKey = '6LfZ3-YlAAAAAH0pVfpyVNOGBTSvQy_1fA1AzVvB'; // v3
subscribeForm?.addEventListener('submit', function (event) {
  event.preventDefault();
  
  // grecaptcha.execute();
  // onSubscribeFormSubmit();
  grecaptcha.ready(function() {
    grecaptcha.execute('6LfZ3-YlAAAAAH0pVfpyVNOGBTSvQy_1fA1AzVvB', {action: 'submit'}).then(function(token) {
      onSubscribeFormSubmit(token);
    });
  });

  
  // Get a reCAPTCHA token to verify the user's identity
  // grecaptcha.execute(recaptchaSiteKey, { action: 'submit' }).then(function(token) {
    // Set the token in the form data
    // document.querySelector('#g-recaptcha-response').value = token;
  
    
});


// function popupBodyOn() {
//   document.body.style.top = '-' + window.scrollY + 'px';
//   document.body.style.position = 'fixed';
// }

// function popupBodyOff() {
//   const scrollY = document.body.style.top;
//   document.body.style.position = '';
//   document.body.style.top = '';
//   window.scrollTo(0, parseInt(scrollY || '0') * -1);
// }